import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import { getSupportedLanguages } from "./reusable/functions";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const Languages = getSupportedLanguages();

// fall back to "de" if nothing is stored or the stored language isn't offered on this market (e.g. "fr" on .de)
const storedLanguage = localStorage.getItem("beppoSelectedLanguage");
if (!Languages.includes(storedLanguage)) {
  localStorage.setItem("beppoSelectedLanguage", "de");
}
export const selectedLanguage = Languages.includes(storedLanguage)
  ? storedLanguage
  : "de";

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "de",
    lng: selectedLanguage ? selectedLanguage : "de",
    debug: false,
    whitelist: Languages,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

const syncHtmlLang = (lng) => {
  if (typeof document !== "undefined" && lng) {
    document.documentElement.lang = lng;
  }
};
syncHtmlLang(i18n.language || selectedLanguage);
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
